import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Image
} from '@chakra-ui/react';
import CustomCheckbox from '@/utils/customCheckbox';
import { getLicenseByZipQueryParams } from '@/explore/ducks/selectors';
import { useDispatch } from 'react-redux';
import { setLicenseByZipQueryParams } from '@/explore/ducks/slice';
import { LicenseByZipParamsInterface } from '@/model/explore';
import { keyType } from '@/queue/types';
import { TRANSFER_DETAILS } from '@/utils/constants';

export const typeList: any = {
  '01 - Firearm Dealer/Gunsmith': '01',
  '02 - Pawnbroker': '02',
  // '03 - Collector of Curios and Relics': '03',
  '06 - Manufacture of Ammunition other than Destructive Devices': '06',
  '07 - Manufacturer of Firearms': '07',
  '08 - Importer of Firearms': '08',
  '09 - Dealer of Destructive Devices': '09',
  '10 - Manufacturer of Destructive Devices': '10',
  '11 - Importer of Destructive Devices': '11'
};

export const gunTypeList: any = [
  {
    label: 'Handgun',
    value: 'pistol'
  },
  {
    label: 'Long Gun',
    value: 'rifle'
  },
  {
    label: 'Other Firearms',
    value: 'sbr'
  }
];

interface LicenseDetailsInterface {
  label: string;
  value: string | Boolean;
  name: string;
}
export const licenseDetails: LicenseDetailsInterface[] = [
  {
    label: 'Exclude Residential',
    value: 'commercial',
    name: 'delivery_indicator'
  },
  { label: 'Has Email Address', value: true, name: 'has_email_address' },
  { label: 'Primary Business', value: true, name: 'primary_gun_business' },
  {
    label: 'Valid License Certificate',
    value: true,
    name: 'has_valid_certificate'
  },
  { label: 'Include Opt Out', value: true, name: 'include_opt_out_dealers' },
  { label: 'Open on Weekend', value: true, name: 'open_on_weekends' },
  { label: 'Include Blacklisted', value: true, name: 'include_blacklisted' }
];

export const reviewList: any = [
  { label: 'All', value: 'all' },
  { label: 'More than 25', value: '25+' },
  { label: '11 to 25', value: '11 - 25' },
  { label: '1 to 10', value: '1 - 10' }
];

export const ratingList: any = [
  {
    label: <>All</>,
    value: 'all'
  },
  {
    label: <>4 &#9733; and above</>,
    value: '4'
  },
  {
    label: <>3 &#9733; and above</>,
    value: '3'
  },
  {
    label: <>2 &#9733; and above</>,
    value: '2'
  },
  {
    label: <>1 &#9733; and above</>,
    value: '1'
  }
];

export function RenderItems({
  item,
  index,
  handler,
  checked,
  value,
  filter,
  label,
  disabled
}: {
  item: string;
  index: number;
  handler: (isChecked: Boolean, value: string, value1?: string) => void;
  checked: Boolean;
    value?: string;
    filter?: string;
    label?: string;
    disabled?: boolean
}) {

  const onCheckboxChange = () => {
    if (!disabled){
      handler(checked, value || item, filter)
    }
  }

  return (
    <Box
      className="license-type-box-list"
      _hover={{ color: '#0090C6' }}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      onClick={() => onCheckboxChange()}
      sx={{opacity: disabled ? 0.4 : 1}}
    >
      <Box
        height={'24px'}
        width={'24px'}
        alignItems={'center'}
        display={'flex'}
        justifyContent={'center'}
      >
        <CustomCheckbox isChecked={checked} />
      </Box>
      <Text className="license-filter-label">{label || item}</Text>
    </Box>
  );
}

export const FilterLicenseType = () => {
  const getParams = getLicenseByZipQueryParams();

  const dispatch = useDispatch();

  function queryHandler(isChecked: Boolean, value: string) {
    let data: LicenseByZipParamsInterface = { ...getParams };
    let licType =
      getParams && getParams.hasOwnProperty('types')
        ? getParams.types?.split(',')
        : [];
    if (!isChecked) licType?.push(typeList[value]);
    else licType = licType?.filter((ele: string) => ele !== typeList[value]);
    delete data.types;
    dispatch(
      setLicenseByZipQueryParams({
        ...data,
        ...(licType?.length && { types: licType?.toString() })
      })
    );
  }

  return (
    <>
      <Box className="license-type-box-wrapper">
        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
          LICENSE TYPE
        </Text>
        <Box marginTop={'15px'}>
          {Object.keys(typeList).map((ele: string, index: number) => {
            return (
              <RenderItems
                item={ele}
                index={index}
                handler={queryHandler}
                checked={
                  getParams.types?.split(',').includes(typeList[ele]) || false
                }
              />
            );
          })}
        </Box>
      </Box>
      <Box className="license-type-box-wrapper license-accordian-filter">
        <Accordion allowToggle defaultIndex={[0]}>
          <AccordionItem className="filter-accordian">
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    background={'#ffffff'}
                    className="filter-accordian-btn"
                  >
                    <Box as="span" flex="1" textAlign="left">
                      LICENSE TYPE
                    </Box>
                    {isExpanded ? (
                      <Image
                        src="/images/ui/downArrow.svg"
                        className="accordian-icon"
                      />
                    ) : (
                      <Image
                        src="/images/ui/upArrow.svg"
                        className="accordian-icon expanded"
                      />
                    )}
                  </AccordionButton>
                </h2>
                <AccordionPanel className="filter-accoridan-panel">
                  <Box>
                    {Object.keys(typeList).map((ele: string, index: number) => {
                      return (
                        <RenderItems
                          item={ele}
                          index={index}
                          handler={queryHandler}
                          checked={
                            getParams.types
                              ?.split(',')
                              .includes(typeList[ele]) || false
                          }
                        />
                      );
                    })}
                  </Box>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};

export const FilterGunType = () => {
  const getParams = getLicenseByZipQueryParams();

  const dispatch = useDispatch();
  function queryHandler(isChecked: Boolean, value: string) {
    let data: LicenseByZipParamsInterface = { ...getParams };
    const gunTypeValue = gunTypeList.find(
      (gunType: any) => gunType.label === value
    );
    let gunType =
      getParams && getParams.hasOwnProperty('gun_type')
        ? getParams.gun_type?.split(',')
        : [];
    if (!isChecked) gunType?.push(gunTypeValue.value);
    else gunType = gunType?.filter((ele: string) => ele !== gunTypeValue.value);
    delete data.gun_type;
    dispatch(
      setLicenseByZipQueryParams({
        ...data,
        ...(gunType?.length && { gun_type: gunType?.toString() })
      })
    );
  }

  return (
    <>
      <Box className="license-type-box-wrapper">
        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} className='text-uppercase'>
          { TRANSFER_DETAILS.FIREARM_TYPE }
        </Text>
        <Box marginTop={'15px'}>
          {gunTypeList.map((ele: any, index: number) => {
            return (
              <RenderItems
                item={ele.label}
                index={index}
                handler={queryHandler}
                checked={
                  getParams.gun_type?.split(',').includes(ele.value) || false
                }
              />
            );
          })}
        </Box>
      </Box>
      <Box className="license-type-box-wrapper license-accordian-filter">
        <Accordion allowToggle defaultIndex={[0]}>
          <AccordionItem className="filter-accordian">
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    background={'#ffffff'}
                    className="filter-accordian-btn"
                  >
                    <Box as="span" flex="1" textAlign="left" className='text-uppercase'>
                      { TRANSFER_DETAILS.FIREARM_TYPE }
                    </Box>
                    {isExpanded ? (
                      <Image
                        src="/images/ui/downArrow.svg"
                        className="accordian-icon"
                      />
                    ) : (
                      <Image
                        src="/images/ui/upArrow.svg"
                        className="accordian-icon expanded"
                      />
                    )}
                  </AccordionButton>
                </h2>
                <AccordionPanel className="filter-accoridan-panel">
                  <Box>
                    {gunTypeList.map((ele: any, index: number) => {
                      return (
                        <RenderItems
                          item={ele.label}
                          index={index}
                          handler={queryHandler}
                          checked={
                            getParams.gun_type
                              ?.split(',')
                              .includes(ele.value) || false
                          }
                        />
                      );
                    })}
                  </Box>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};

export const FilterLicenseDetails = () => {
  const getParams: LicenseByZipParamsInterface = getLicenseByZipQueryParams();

  const dispatch = useDispatch();

  function queryHandler(isChecked: Boolean, value: string) {
    let licenseFilters: LicenseByZipParamsInterface = { ...getParams };
    let filterName = licenseDetails.filter(
      (item: LicenseDetailsInterface) => item.label === value
    );
    if (!isChecked)
      Object.assign(licenseFilters, {
        [filterName[0].name]: filterName[0].value
      });
    else
      delete licenseFilters[
        filterName[0].name as keyType<typeof licenseFilters>
      ];
    dispatch(setLicenseByZipQueryParams({ ...licenseFilters }));
  }

  return (
    <>
      <Box className="license-type-box-wrapper">
        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
          LICENSE DETAIL
        </Text>
        <Box marginTop={'15px'}>
          {licenseDetails.map((ele: LicenseDetailsInterface, index: number) => {
            return (
              <RenderItems
                item={ele.label}
                index={index}
                handler={queryHandler}
                checked={
                  getParams[ele.name as keyType<typeof getParams>] === ele.value
                }
              />
            );
          })}
        </Box>
      </Box>
      <Box className="license-type-box-wrapper license-accordian-filter">
        <Accordion allowToggle defaultIndex={[0]}>
          <AccordionItem className="filter-accordian">
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    background={'#ffffff'}
                    className="filter-accordian-btn"
                  >
                    <Box as="span" flex="1" textAlign="left">
                      LICENSE DETAIL
                    </Box>
                    {isExpanded ? (
                      <Image
                        src="/images/ui/downArrow.svg"
                        className="accordian-icon"
                      />
                    ) : (
                      <Image
                        src="/images/ui/upArrow.svg"
                        className="accordian-icon expanded"
                      />
                    )}
                  </AccordionButton>
                </h2>
                <AccordionPanel className="filter-accoridan-panel">
                  <Box>
                    {licenseDetails.map(
                      (ele: LicenseDetailsInterface, index: number) => {
                        return (
                          <RenderItems
                            item={ele.label}
                            index={index}
                            handler={queryHandler}
                            checked={
                              getParams[
                                ele.name as keyType<typeof getParams>
                              ] === ele.value
                            }
                          />
                        );
                      }
                    )}
                  </Box>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};

export const FilterReviews = () => {
  const getParams = getLicenseByZipQueryParams();

  const dispatch = useDispatch();

  function handleReviews(value: string) {
    let data: LicenseByZipParamsInterface = {
      ...getParams,
      min_review_count: value
    };
    if (value === 'all') delete data.min_review_count;
    else data = { ...getParams, min_review_count: value };
    dispatch(setLicenseByZipQueryParams({ ...data }));
  }
  return (
    <>
      <Box className="license-type-box-wrapper">
        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
          REVIEWS
        </Text>
        <Box marginTop={'15px'}>
          <RadioGroup
            onChange={handleReviews}
            value={getParams.min_review_count || 'all'}
          >
            <Stack direction="column">
              {reviewList.map((ele: any, index: number) => (
                <Box _hover={{ color: '#0090C6' }} key={index}>
                  <Radio value={ele.value}>{ele.label}</Radio>
                </Box>
              ))}
            </Stack>
          </RadioGroup>
        </Box>
      </Box>
      <Box className="license-type-box-wrapper license-accordian-filter">
        <Accordion allowToggle defaultIndex={[0]}>
          <AccordionItem className="filter-accordian">
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    background={'#ffffff'}
                    className="filter-accordian-btn"
                  >
                    <Box as="span" flex="1" textAlign="left">
                      REVIEWS
                    </Box>
                    {isExpanded ? (
                      <Image
                        src="/images/ui/downArrow.svg"
                        className="accordian-icon"
                      />
                    ) : (
                      <Image
                        src="/images/ui/upArrow.svg"
                        className="accordian-icon expanded"
                      />
                    )}
                  </AccordionButton>
                </h2>
                <AccordionPanel className="filter-accoridan-panel">
                  <Box>
                    <RadioGroup
                      onChange={handleReviews}
                      value={getParams.min_review_count || 'all'}
                    >
                      <Stack direction="column">
                        {reviewList.map((ele: any, index: number) => (
                          <Box _hover={{ color: '#0090C6' }}>
                            <Radio value={ele.value}>{ele.label}</Radio>
                          </Box>
                        ))}
                      </Stack>
                    </RadioGroup>
                  </Box>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};

export const FilterRatings = () => {
  const getParams = getLicenseByZipQueryParams();

  const dispatch = useDispatch();

  function handleRatings(value: string) {
    let data: LicenseByZipParamsInterface = {
      ...getParams,
      min_rating_count: value
    };
    if (value === 'all') delete data.min_rating_count;
    else data = { ...getParams, min_rating_count: value };
    dispatch(setLicenseByZipQueryParams({ ...data }));
  }
  return (
    <>
      <Box className="license-type-box-wrapper">
        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
          RATING
        </Text>
        <Box marginTop={'15px'}>
          <RadioGroup
            onChange={handleRatings}
            value={getParams.min_rating_count || 'all'}
          >
            <Stack direction="column">
              {ratingList.map((ele: any, index: number) => (
                <Box _hover={{ color: '#0090C6' }}>
                  <Radio value={ele.value}>{ele.label}</Radio>
                </Box>
              ))}
            </Stack>
          </RadioGroup>
        </Box>
      </Box>
      <Box className="license-type-box-wrapper license-accordian-filter">
        <Accordion allowToggle defaultIndex={[0]}>
          <AccordionItem className="filter-accordian">
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    background={'#ffffff'}
                    className="filter-accordian-btn"
                  >
                    <Box as="span" flex="1" textAlign="left">
                      RATING
                    </Box>
                    {isExpanded ? (
                      <Image
                        src="/images/ui/downArrow.svg"
                        className="accordian-icon"
                      />
                    ) : (
                      <Image
                        src="/images/ui/upArrow.svg"
                        className="accordian-icon expanded"
                      />
                    )}
                  </AccordionButton>
                </h2>
                <AccordionPanel className="filter-accoridan-panel">
                  <Box>
                    <RadioGroup
                      onChange={handleRatings}
                      value={getParams.min_rating_count || 'all'}
                    >
                      <Stack direction="column">
                        {ratingList.map((ele: any, index: number) => (
                          <Box _hover={{ color: '#0090C6' }}>
                            <Radio value={ele.value}>{ele.label}</Radio>
                          </Box>
                        ))}
                      </Stack>
                    </RadioGroup>
                  </Box>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        </Accordion>
      </Box>
    </>
  );
};
